import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import EN from './en/index.json';
import JA from './ja/index.json';
import ZH from './zh/index.json';
import Env from '@/Api/domain'

export const resources = {
  en: {
    translation: EN,
  },
  ja: {
    translation: JA,
  },
  zh: {
    translation: ZH,
  },
} as const;

const i18n = i18next.createInstance();

i18n.use(initReactI18next).init({
  lng: `${Env.getLanguage()}` ?? 'ja',
  fallbackLng: `${Env.getLanguage()}`?? 'ja',
  debug: true,
  interpolation: {
    escapeValue: false,
    formatSeparator: ','
  },
  resources,
});



type LocalRecord<U, T extends keyof U> = {
  [P in T]: U[P];
};

// export const ENLocalKeyMap = Object.keys(EN).reduce(
//   (pre, next: keyof typeof EN) => {
//     pre[next] = next;
//     return pre;
//   },
//   {} as Record<keyof typeof EN, keyof typeof EN>,
// ) as unknown as LocalRecord<typeof EN, keyof typeof EN>;

// export const INDLocalKeyMap = Object.keys(IND).reduce(
//   (pre, next: keyof typeof IND) => {
//     pre[next] = next;
//     return pre;
//   },
//   {} as Record<keyof typeof IND, keyof typeof IND>,
// ) as unknown as LocalRecord<typeof IND, keyof typeof IND>;

// 1、振込銀行情報
// 口座名義
// 银行名2 銀行情報
// 銀行名  住信SBIネット銀行
// 支店名   法人第一支店(106)
// 口座種類 普通
// 口座名義 株式会社ますＨＤ
// 口座番号 2035669
// 購入ポイント ----PT
// 金額 ￥----.03 購入成功
// 運営が銀行の入金を確認後、ポイントの購入が完了します。少し時間がかかる場合がありますので、何か問題があれば、LINEでご連絡ください

/** 方便中文map */
export const LocalKeyMap = Object.keys({ ...JA, ...EN, ...ZH }).reduce(
  (pre, next: keyof typeof EN) => {
    pre[next] = next;
    return pre;
  },
  {} as Record<keyof typeof EN, keyof typeof EN>,
) as unknown as LocalRecord<typeof EN, keyof typeof EN>;

export default i18n;
